/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppDispatch } from '../redux/store';
import { CurrentUser } from '../params/redux';
import { EmailObject } from '../params/redux/email';
import { fetchFormsThunk } from '../redux/thunks/form';
import { fetchLeadsThunk } from '../redux/thunks/lead';
import { fetchUserMailsThunk } from '../redux/thunks/email';
import { fetchUserSMSThunk } from '../redux/thunks/sms';
import { FormObject } from '../params/redux/form';
import { LeadObject } from '../params/redux/leads';
import { markReadUnreadNotificaitonThunk } from '../redux/thunks/notification';
import { setIsSales } from '../redux/slices';
import { SMSObject } from '../params/redux/sms';
import { NotificaitonObject, NotificationReadUnreadParams } from '../params/redux/notification';
import { settingComposingFlagEmail, settingSelectedEmail } from '../redux/slices/email';
import { settingComposingFlagSMS, settingSelectedSMS } from '../redux/slices/sms';
import { settingSelectedDeal, settingSelectedEmailAndSMSTab, settingViewDetail } from '../redux/slices/deal';
import { settingSelectedForm, settingSelectedFormFlag } from '../redux/slices/form';
import { settingSelectedLead, settingSelectedLeadFlag, settingSelectedLeadTab } from '../redux/slices/leads';

/* eslint-disable max-statements */
export const handleNotificationOnClick = async (
    notif: NotificaitonObject,
    dispatch: AppDispatch,
    navigate: any,
    handleClose: any,
    currentUser: CurrentUser | null,
    isSales: boolean
) => {
    if (notif.type !== 'general' && isSales) {
        dispatch(setIsSales(!isSales));
    }
    if (notif.type === 'lead') {
        const formResponse: {
            forms: FormObject[]
        } = await dispatch(fetchFormsThunk(currentUser?.client_id as number)).unwrap() as any;
        const leadResponse: LeadObject[] = await dispatch(fetchLeadsThunk(currentUser?.client_id as number)).unwrap() as any;
        const selectedFormFromForms = formResponse.forms.find((form: FormObject) => form.id === notif.form_id);
        const selectedLead = leadResponse.find((l: LeadObject) => l.id === notif.lead_id);
        dispatch(settingSelectedForm(selectedFormFromForms));
        dispatch(settingSelectedFormFlag(true));
        dispatch(settingSelectedLead(selectedLead));
        dispatch(settingSelectedLeadFlag(true));
        dispatch(settingSelectedSMS(null));
        dispatch(settingSelectedEmail(null));
        dispatch(settingSelectedLeadTab(0));
        dispatch(settingComposingFlagSMS(false));
        dispatch(settingComposingFlagEmail(false));
        handleClose();
        navigate('/app/leads');
    } else if (notif.type === 'sms') {
        if (notif.lead_id) {
            navigate('/app/leads');
            const formResponse: {
                forms: FormObject[]
            } = await dispatch(fetchFormsThunk(currentUser?.client_id as number)).unwrap() as any;
            const leadResponse: LeadObject[] = await dispatch(fetchLeadsThunk(currentUser?.client_id as number)).unwrap() as any;
            const selectedLead = leadResponse.find((l: LeadObject) => l.id === notif.lead_id);
            dispatch(settingSelectedLead(selectedLead));
            const messages: SMSObject[] = await dispatch(fetchUserSMSThunk(currentUser?.client_id as number)).unwrap() as any;
            const selectedFormFromForms = formResponse.forms.find((form: FormObject) => form.id === notif.form_id);
            const selectedSMS = messages.find((sms: SMSObject) => sms.lead_id === notif.lead_id && sms.message_to === notif.from_number);
            dispatch(settingSelectedSMS(selectedSMS));
            dispatch(settingSelectedForm(selectedFormFromForms));
            dispatch(settingSelectedFormFlag(true));
            dispatch(settingSelectedLeadFlag(true));
            dispatch(settingSelectedLeadTab(2));
            handleClose();
        } else if (notif.deal_id) {
            // deal
            const messages: SMSObject[] = await dispatch(fetchUserSMSThunk(currentUser?.client_id as number)).unwrap() as any;
            const selectedSMS = messages.find((sms: SMSObject) => sms.deal_id === notif.deal_id && sms.message_to === notif.from_number);
            dispatch(settingSelectedSMS(selectedSMS));
            dispatch(settingSelectedDeal({
                id: notif.deal_id
            }));
            dispatch(settingViewDetail(true));
            dispatch(settingComposingFlagSMS(false));
            dispatch(settingSelectedEmailAndSMSTab(false));
            handleClose();
            navigate('/app/deals');
        }
    } else if (notif.type === 'email') {
        if (notif.lead_id) {
            navigate('/app/leads');
            const leadResponse: LeadObject[] = await dispatch(fetchLeadsThunk(currentUser?.client_id as number)).unwrap() as any;
            const selectedLead = leadResponse.find((l: LeadObject) => l.id === notif.lead_id);
            dispatch(settingSelectedLead(selectedLead));
            const messages: EmailObject[] = await dispatch(fetchUserMailsThunk(currentUser?.client_id as number)).unwrap() as any;
            const formResponse: { forms: FormObject[] } = await dispatch(fetchFormsThunk(currentUser?.client_id as number)).unwrap() as any;
            const selectedEmail = messages.find((mail: EmailObject) => mail.lead_id === notif.lead_id && mail.to_email === notif.from_email);
            const selectedFormFromForms = formResponse.forms.find((form: FormObject) => form.id === notif.form_id);
            dispatch(settingSelectedEmail(selectedEmail));
            dispatch(settingSelectedForm(selectedFormFromForms));
            dispatch(settingSelectedFormFlag(true));
            dispatch(settingSelectedLeadFlag(true));
            dispatch(settingComposingFlagSMS(false));
            dispatch(settingSelectedLeadTab(1));
            handleClose();
        } else if (notif.deal_id) {
            // deal
            dispatch(settingSelectedDeal({ id: notif.deal_id }));
            navigate('/app/deals');
            const messages: EmailObject[] = await dispatch(fetchUserMailsThunk(currentUser?.client_id as number)).unwrap() as any;
            const selectedEmail = messages.find((mail: EmailObject) => mail.deal_id === notif.deal_id && mail.to_email === notif.from_email);
            dispatch(settingViewDetail(true));
            dispatch(settingSelectedEmail(selectedEmail));
            dispatch(settingComposingFlagSMS(false));
            dispatch(settingSelectedEmailAndSMSTab(true));
            handleClose();
        }
    }
    if (notif.is_read === 1) return;
    const data: NotificationReadUnreadParams = {
        notification_id: notif.id,
        is_all: 0,
        is_read: 1
    };
    await dispatch(markReadUnreadNotificaitonThunk(data)).unwrap();
};